<div class="select">
  <div
    #monthSelectModal
    class="date"
    [style.border-radius]="statisticsStyle ? '0 4px 4px 0' : '4px'"
    #origin
    (click)="displayMenu()"
  >
    <div
      class="custom-component-display-frame"
      [class.border]="from === 'note'"
      [style.border-radius]="statisticsStyle ? '0 4px 4px 0' : '4px'"
    >
      <div
        *ngIf="time !== null"
        class="normal-text"
        [style.width]="showWidth ? showWidth - 42 : 'auto'"
      >
        {{ time }}
      </div>
      <div
        *ngIf="time === null"
        class="placeholder"
        [style.width]="showWidth ? showWidth - 42 : 'auto'"
      >
        {{ "placeholder.share_month_required" | translate }}
      </div>
    </div>
    <div class="icon">
      <div *ngIf="!isOpen">
        <i nz-icon nzType="caret-down" nzTheme="outline"></i>
      </div>
      <div *ngIf="isOpen">
        <i nz-icon nzType="caret-up" nzTheme="outline"></i>
      </div>
    </div>
  </div>
</div>
<ng-template #monthSelectPanel>
  <div class="template">
    <div class="choose-time">
      <div class="year-range">
        <div class="left">
          <div
            class="sub"
            style="padding: 0 69px 0 20px;"
            (click)="changeYear(0)"
          >
            <<
          </div>
          <!-- <p>{{ leftYear }}年</p> -->
          <p>{{ leftYear }}{{ "component.search.year" | translate }}</p>
        </div>
        <div class="right">
          <div
            class="add"
            style="padding: 0 20px 0 69px;"
            (click)="changeYear(1)"
          >
            >>
          </div>
          <!-- <p>{{ rightYear }}年</p> -->
          <p>{{ rightYear }}{{ "component.search.year" | translate }}</p>
        </div>
      </div>
      <div class="month">
        <div class="left" nz-row>
          <div
            nz-col
            [nzSpan]="8"
            *ngFor="let month of leftMonths; index as i"
            [ngClass]="{
              item: !month.uncheck
            }"
            (click)="chooseMonth(month, i)"
          >
            <div
              [ngClass]="{
                checked: month.checked,
                range: month.range
              }"
            >
              {{ month.title }}
            </div>
          </div>
        </div>
        <div class="right" nz-row>
          <div
            nz-col
            [nzSpan]="8"
            *ngFor="let month of rightMonths; index as i"
            [ngClass]="{
              item: !month.uncheck
            }"
            (click)="chooseMonth(month, i)"
          >
            <div
              [ngClass]="{
                checked: month.checked,
                range: month.range
              }"
            >
              {{ month.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="quick-choice" (click)="quickChoose('去年')">
        {{ "component.search.last_year" | translate }}
      </div>
      <div class="quick-choice" (click)="quickChoose('今年')">
        {{ "component.search.this_year" | translate }}
      </div>
    </div>
  </div>
</ng-template>
